var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3992 15.1002C13.7188 15.1002 15.5992 13.2198 15.5992 10.9002C15.5992 8.5806 13.7188 6.7002 11.3992 6.7002C9.07962 6.7002 7.19922 8.5806 7.19922 10.9002C7.19922 13.2198 9.07962 15.1002 11.3992 15.1002Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9878 0.700195H9.4122C3.5154 0.700195 0 4.34579 0 10.461V24.5394C0 26.3706 0.3078 27.9666 0.9072 29.3106C2.3004 32.5026 5.2812 34.3002 9.4122 34.3002H22.9878C28.8846 34.3002 32.4 30.6546 32.4 24.5394V20.6922V10.461C32.4 4.34579 28.8846 0.700195 22.9878 0.700195ZM29.7594 18.3402C28.4958 17.2146 26.4546 17.2146 25.191 18.3402L18.4518 24.3378C17.1882 25.4634 15.147 25.4634 13.8834 24.3378L13.3326 23.8674C12.1824 22.8258 10.3518 22.725 9.0558 23.6322L2.997 27.849C2.6406 26.9082 2.43 25.8162 2.43 24.5394V10.461C2.43 5.7234 4.8438 3.2202 9.4122 3.2202H22.9878C27.5562 3.2202 29.97 5.7234 29.97 10.461V18.525L29.7594 18.3402Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioImage);
export default __webpack_public_path__ + "static/media/audio-image.521648b072a93564777c637ea0145241.svg";
export { ForwardRef as ReactComponent };